// This icon file is generated automatically.
var PCrownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 16 16", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M14.06 4.32l-3.04 1.87L8.1 2.3a.13.13 0 00-.2 0L4.98 6.2 1.94 4.31a.13.13 0 00-.19.12l1.2 9.08c.01.12.12.21.25.21h9.6c.13 0 .24-.09.25-.21l1.2-9.08a.13.13 0 00-.2-.12zm-1.97 8.35H3.9l-.84-6.4L5.25 7.6 8 3.95l2.75 3.66 2.18-1.34-.84 6.4zM8 7.95a1.76 1.76 0 100 3.53 1.76 1.76 0 000-3.53zm0 2.52a.75.75 0 110-1.51.75.75 0 010 1.5z", "fill-rule": "nonzero" } }] }, "name": "p-crown", "theme": "outlined" };
export default PCrownOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCrownOutlined.js
// module id = 3312
// module chunks = 0